<template>
  <div class="main-box" v-loader.opacity="loading">
    <div class="no-results-box" v-if="alert.message">
      <BaseNoResults :title="alert.title" :text="alert.message"/>
    </div>

    <BaseTable class="no-border non-clickable" v-if="tableDevice && !alert.message" :tabledata="tableDevice" />

    <teleport :to="`#${slotPagination}`" v-if="isDataReady">
      <div v-if="tableDevice" class="align-items-center page-row">
        <p class="pagination-total">{{ `${tableDevice.total} ${$t("pagination.devices")}` }}</p>
          <BasePagination :total-pages="totalPages" :total="tableDevice.total"
                          :per-page="perPage" :current-page="currentPage" @pagechanged="onPageChange"/>
      </div>
    </teleport>

    <teleport to="#settingsActionBar" v-if="isDataReady">
      <button class="btn btn-success" type="button" name="button" @click="newDevice" data-test="btnAdd">
        {{ $t('device.add') }}
      </button>
    </teleport>

    <DeviceAddNewOffcanvas :offcanvas_id="'newDevice'" ref="offcanvasNewDevice"/>
  </div>
</template>

<style lang="scss" scoped>
.main-box {
  padding:                           10px;
}

// .non-clickable {
//   pointer-events:                    none;
// }

@media (max-width: 991px) {
  .main-box,
  .no-results-box {
    height:                          100%;
    text-align:                      center;
  }
}
</style>

<script>
import DeviceAddNewOffcanvas from './DeviceAddNewOffcanvas.vue'

export default {
  name: 'device-list',
  components: {
    DeviceAddNewOffcanvas
  },
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null,
    },
    tableDevice: {
      items: [],
      total: 0,
      columns: []
    },
    perPage: 20,
    currentPage: 1,
    totalPages: 0,
    isDataReady: false,
    slotPagination: 'settingsPagination',
  }),
  mounted() {
    this.$activeLink.value = 'device'
    this.fetchData()

    this.handleResize()
    window.addEventListener('resize', this.handleResize);
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    async fetchData() {
      this.alert = {}
      let params = {
        page: this.currentPage
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$deviceService.getList(params)

        this.tableDevice = {
          'items': response.result,
          'total': response.totalCount,
          'columns': [
            {name: 'Serial', type: 'string', value: 'serialNumber', width: '100%'},
            //{name: this.$i18n.t('device.type'), type: 'string', value: 'type', width: '33.3%'},
            //{name: this.$i18n.t('device.lastActivity'), type: 'string', value: 'lastActivity', width: '33.3%'}
          ]
        };

        this.totalPages = Math.ceil(response.totalCount / this.perPage);

        if (!response || response?.totalCount === 0) {
          this.tableDevice = { items: [], total: 0, columns: [] };
          this.totalPages = 1
          this.alert = this.$message.alertWithTitle(this, 'request_notfound_device_title', 'request_notfound_device_text')
          // this.$message.popup(this, 'request_notfound', 'operationWarning', 'warn')
        }
      } catch (err) {
        console.log("error", err)
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      } finally {
        NProgress.done(true)
        this.loading = false
        this.isDataReady = true
      }
    },
    toDetails(item) {
      this.$router.push({name: 'device-show', params: {deviceID: item.id}, query: {tab: 'data'}})
    },
    async newDevice() {
      const ok = await this.$refs.offcanvasNewDevice.show({
        cancelButton: this.$i18n.t('cancel'),
        cancelButtonClass: 'btn-outline-secondary',
      })
      if (ok) {
        this.fetchData()
        // this.$router.push({name: 'patient-create', params: {patientID: ''}})
      }
    },
    handleResize() {
      this.slotPagination = window.innerWidth > 767 ? 'settingsPagination' : 'settingsPaginationMobile'
    },
  }
}
</script>
